import { render, staticRenderFns } from "./index.vue?vue&type=template&id=671555ba&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=671555ba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671555ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('671555ba')) {
      api.createRecord('671555ba', component.options)
    } else {
      api.reload('671555ba', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=671555ba&scoped=true", function () {
      api.rerender('671555ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/placesProvider/index.vue"
export default component.exports